module.exports = __webpack_public_path__ + "media/images/brandmaker_mobile-a52460495f5c44e0d8f11322a551c676.png";